module.exports = __webpack_public_path__ + "img/right-arrow.57e72724.svg";